export default __webpack_public_path__ + "static/media/experiences_item_yellow.a08bada2.svg";